/**
 * 이상한 방 - 페이즈 길이 산술
 *
 * 근거 문서: `이상한방-컨셉시트-v0.1.md` 3절(라운드 구조)
 *            `이상한방-상태모델-v0.1.md` 11.3절(서버가 쥐는 것 - 페이즈 전환·타이머)
 *
 * ## 왜 `gameState.ts`에서 뽑았는가
 *
 * 리빌 길이는 "미발견이 몇 개인가"에서 나온다. 싱글은 그 수를 `GameState`에서 세지만
 * 매치는 공유 발견 목록에서 센다 - 세는 곳이 다르고 **곱하는 규칙은 같아야** 한다.
 * 규칙이 두 리듀서에 각각 있으면 튜닝 한 번에 한쪽만 바뀌고, 그 어긋남은 "리빌이 왜 일찍
 * 끊기지"로만 드러나 원인을 찾기 어렵다. 그래서 개수를 받아 시간을 돌려주는 함수 하나로 묶는다.
 *
 * 외우기·수색 길이는 튜닝값 그대로라 함수로 감쌀 것이 없다. 여기 없는 것은 규칙이 없다는 뜻이다.
 */

import { MS_PER_SECOND } from '../core/time'
import type { Tuning } from './tuning'

/**
 * 리빌 최소 길이(변화 1건 분량).
 *
 * 12개를 전부 찾아 미발견이 0이어도 리빌을 건너뛰지 않는다. 완주는 이 게임에서 가장 드문 사건인데
 * 그 순간 화면이 결과창으로 즉시 넘어가면 축하가 아니라 버그처럼 보인다.
 */
export const REVEAL_MIN_STEPS = 1

/** 이 파일이 읽는 튜닝 값. `Tuning` 전체가 구조적으로 만족하므로 그대로 넘긴다. */
export type RevealClockTuning = Pick<Tuning, 'revealSecondsPerChange'>

/**
 * 리빌 페이즈 길이(ms). 미발견 하나에 `revealSecondsPerChange`씩, 최소 한 건 분량.
 *
 * 발견분은 세지 않는다 - 리빌 연출(`reveal.ts`)이 발견분을 짧게 훑기는 하지만 그것은 남은 시간
 * 안에서 템포를 나누는 일이고, 페이즈 길이는 "못 본 것을 보여 주는 시간"으로만 정한다.
 */
export function revealDurationMs(unfoundCount: number, tuning: RevealClockTuning): number {
  const steps = Math.max(unfoundCount, REVEAL_MIN_STEPS)
  return steps * tuning.revealSecondsPerChange * MS_PER_SECOND
}
